var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurteam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1135,
    height: 1018,
    viewBox: "0 0 1135 1018",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_31_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M858 615C858 716.068 779.069 798 681.704 798C584.338 798 518.5 716.068 518.5 615C518.5 513.932 584.338 432 681.704 432C779.069 432 858 513.932 858 615Z",
    fill: "#F05CDC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_31_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.704 423C509.704 503.634 444.022 569 363 569C281.978 569 276.704 503.634 276.704 423C276.704 342.366 281.978 277 363 277C444.022 277 509.704 342.366 509.704 423Z",
    fill: "#6C0B87"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_31_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M627 526C627 606.634 561.319 672 480.296 672C399.274 672 394 606.634 394 526C394 445.366 399.274 380 480.296 380C561.319 380 627 445.366 627 526Z",
    fill: "#FC88CE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_31_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.204 646.5C581.204 727.134 515.523 792.5 434.5 792.5C353.478 792.5 348.204 727.134 348.204 646.5C348.204 565.866 353.478 500.5 434.5 500.5C515.523 500.5 581.204 565.866 581.204 646.5Z",
    fill: "#B14BDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_31_132",
    x: 242.1,
    y: 155.6,
    width: 892.3,
    height: 918.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_132"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_31_132",
    x: 0.303619,
    y: 0.600006,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_132"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_31_132",
    x: 117.6,
    y: 103.6,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_132"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_31_132",
    x: 71.8041,
    y: 224.1,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_132"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurteam);
export default __webpack_public_path__ + "static/media/ourteam.f66de5fd92e2ca424893ac4e458e6af7.svg";
export { ForwardRef as ReactComponent };